import React from 'react';
import './AddSite.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';

const AddSite = () => {
return( 
<div>
    <SideMenuBar></SideMenuBar>     
    <div class="content">
         <NewHeader></NewHeader>
        
          <div className='row2'>
            <h3 className='directory_Directory'>Add Site</h3>  
          </div>

          <div className='row4_AddSite'>
            <input className='siteName_input_AddSite' placeholder='Enter Site Name'></input>
          </div>

          <div class="row5_AddSite">
            <div class="row5_column1_AddSite">
              <p>Assignee</p>
              <input className='input_AddSite' placeholder='Enter Assignee'></input>

              <p>Site Owner</p>
              <input className='input_AddSite' placeholder='Enter Site Owner'></input>

              <p>Address</p>
              <textarea className='textArea_input_AddSite' placeholder='Enter Address'></textarea><br/>

            </div>
  
            <div class="row5_column2_AddSite">
              <p>Phone No.</p>
              <input className='input_AddSite' placeholder='Enter Phone No.'></input>

              <p>Email ID</p>
              <input className='input_AddSite' placeholder='Enter Email ID'></input>

              <p>Materials Used</p>
              <textarea className='textArea_input_AddSite' placeholder='Enter Materials Used'></textarea><br/>
              <button className='add_btn_input_AddSite'>Add</button>
            </div>
          </div>  
          
    </div>
</div>
 )
}

export default AddSite;